export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
];